import React from 'react'
import { Outlet } from 'react-router-dom';
import { Col } from 'reactstrap';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './sidebar/Sidebar';

export default function Index() {
    return (
        <>
            <Header />
            <div className="main_sidebar_area d-md-block sidebar hide-sidebar">
                <Sidebar />
            </div>
            <div className="main_content_area ms-sm-auto p-3 full-stretch">
                <main className='main_container'>
                    <Outlet />
                </main>
                {/* <Footer /> */}
            </div>
        </>
    )
}
